import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { fontFamily } from 'components/views/default';

const DisplayAreaName = styled.h3({
    fontFamily,
    marginBottom: '0.5ex',
});

const AddButtonBox = styled.div({
    display: 'flex',
    alignItems: 'center',
});

export type SettingFormGroupProps<T> = {
    groupName: string;
    addLabel: string;
    max?: number;
    forms: Partial<T>[];
    onChange: (forms: Partial<T>[]) => void;
}

export function SettingFormGroup<T>(props: React.PropsWithChildren<SettingFormGroupProps<T>>) {
    const { groupName, addLabel, max, forms } = props;

    return (
        <React.Fragment>
            <DisplayAreaName>{groupName}</DisplayAreaName>
            {props.children}
            {
                (!max || forms.length < max)
                    ? (
                        <AddButtonBox>
                            <Button sx={{
                                color: theme => theme.palette.primary.main,
                            }} size='small' onClick={() => props.onChange([...forms, {}])}>
                                <Add />
                                {addLabel}
                            </Button>
                        </AddButtonBox>
                    )
                    : <React.Fragment />
            }
        </React.Fragment>
    );
}
